export function videoModal() {
    let $modal = $(".global-pop-up");
    let $iframeScr;
    let $src;

    $("body").on("click", ".video-pop-up", function () {
        $iframeScr = $(this).attr("data-src");
        if ($(this).attr("data-src") == undefined) {
            $iframeScr = $(this).parent().find(".video-play-button").attr("data-src");
        }

        let iframe = `
        <div class="iframe-wrapper">
        <button class="close-pop-up">
            <span></span>
            <span></span>
        </button>
        <iframe align="absmiddle" class="video-iframe" width="100%" height="770" title="Video player" frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen crossorigin src="">
        </iframe>
        </div>`;

        $modal.find(".video-holder").append(iframe);

        let $iframe = $modal.find("iframe");

        if ($iframeScr.match(/youtube/g)) {
            $src = `${$iframeScr}?rel=0&modestbranding=1&autoplay=1&mute=0&showinfo=0autohide=1`;
        }
        if ($iframeScr.match(/matterport/g)) {
            $src = `${$iframeScr}&play=1`;
        } else if (
            !$iframeScr.match(/youtube/g) &&
            !$iframeScr.match(/matterport/g)
        ) {
            $src = $iframeScr;
        }

        $iframe.attr("src", $src);
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/videoModal.js